import { Translate } from 'next-translate'
import { defined } from 'shared/presenters/presenter'

type Attendants = {
  adults?: number
  children?: number
}

const getPeopleGoingText = (
  attendants: Attendants,
  t: Translate,
  // It will translate as 1x adult instead of 1 adult if showSymbol is true
  showSymbol?: boolean
) => {
  const attendantTypes = Object.keys(attendants) as Array<keyof Attendants>

  const textArray = attendantTypes
    .filter(
      attendantType =>
        // Number.isInteger(attendants[attendantType]) &&
        // avoid rendering attendants with no values to avoid text such as '0 adults'
        // appearing in the UI
        defined(attendants[attendantType]) > 0
    )
    .map(attendantType =>
      t(`common:${showSymbol ? 'x-time-' : 'x-'}${attendantType}`, {
        count: attendants[attendantType] ?? 0
      })
    )

  if (!textArray.length) {
    return ''
  }

  return textArray.reduce((a, b) => a + ', ' + b)
}

export default getPeopleGoingText
